import styled from "styled-components";
import { ButtonDesign, ButtonSize, IconKind } from "@util/types";
import { btnDesign, btnSize } from "@util/constants";

interface Props {
  design?: ButtonDesign;
  buttonSize?: ButtonSize;
  useIcon?: IconKind;
}

export const StyledLink = styled.div<Props>`
  ${({ design, useIcon, buttonSize }) => buttonStyles({ design, useIcon, buttonSize })};
  height: 100%;
`;

export function buttonStyles({ design, useIcon, buttonSize }: Props) {
  const iconStyle = useIcon
    ? `
    display:inline-block;
    position:relative;
    padding-right:40px;
    span:first-child{
      display:block;
    }
    span:last-child{
      position:absolute;
      height:100%;
      top:0;
      right:15px;
      display:flex;
      align-items:center;
    }
  `
    : "";

  const size =
    (buttonSize && buttonSize === `l` && useIcon && btnSize.lWithIcon) ||
    (buttonSize && buttonSize === `l` && useIcon == null && btnSize.l);
  const designOutput = design ? btnDesign[design] : btnDesign[`textDark`];

  return `${btnDesign.default}${designOutput}${iconStyle}${size}`;
}
